import { render, staticRenderFns } from "./AxRoadButton.vue?vue&type=template&id=d1538d62&"
import script from "./AxRoadButton.vue?vue&type=script&lang=js&"
export * from "./AxRoadButton.vue?vue&type=script&lang=js&"
import style0 from "./AxRoadButton.vue?vue&type=style&index=0&id=d1538d62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports